import { precisionRound } from 'common/utilities/core/number';
import { ThemeColors } from 'core/utilities/theme';
import React from 'react';
import type { SequenceAlign } from 'sequenceAnalyser/api/sequenceAnalyserApiClient';
import type { ColumnsLetterOccurrences } from 'sequenceAnalyser/utilities/colorCalculations/colorCalculations';

export interface ComponentProps {
  alignedSequences: SequenceAlign[];
  columnsLetterOccurrences: ColumnsLetterOccurrences;
  columnWidth: number;
  height: number;
  width: number;
}

function SequenceConservation({
  alignedSequences, columnsLetterOccurrences, columnWidth, width, height,
}: ComponentProps) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        {(Object.keys(columnsLetterOccurrences)).map((columnPositionStr) => {
          const columnPosition = Number(columnPositionStr);
          const letterOccurrences = columnsLetterOccurrences[columnPosition];
          const letters = Object.keys(letterOccurrences);
          const maxCount = Math.max(...letters.map((l) => letterOccurrences[l].count));
          const columnConservation = maxCount / alignedSequences.length;
          const columnHeight = columnConservation * height;

          return (
            <g key={columnPosition.toString()}>
              <rect
                x={(columnPosition * columnWidth) + 1}
                y={height - columnHeight}
                width={columnWidth}
                height={columnHeight}
                fill={ThemeColors.textColor}
              >
                <title>{`Score: ${precisionRound(columnConservation, 2)} - Position: ${columnPosition + 1}`}</title>
              </rect>
              <line
                x1={(columnPosition * columnWidth) + 1 + columnWidth}
                x2={(columnPosition * columnWidth) + 1 + columnWidth}
                y1={height - columnHeight}
                y2={height}
                stroke={ThemeColors.textHover}
              />
            </g>
          );
        })}
      </g>
    </svg>
  );
}

export default SequenceConservation;
